export const AmexIcon = (props) => (
  <svg
    width="22"
    height="19"
    viewBox="0 0 336 294"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 131.723V293.723H200.453L219.769 269.218L238.793 293.723H336L268.537 213.453L336 131.723H240.299L220.618 155.714L201.567 131.723H24Z"
      fill="white"
    />
    <path
      d="M37.3931 0L0 87.1765V156.609H46.1989L56.0614 131.922H82.5478L92.4805 156.609H309.5V0H228.549L216.302 35.2948L203.669 0H123.282V48.8328L102.061 0H37.3931Z"
      fill="white"
    />
    <path
      d="M50.6285 19.3063L0.193359 136.57H33.0293L42.3352 113.089H96.4348L105.693 136.57H139.252L88.8647 19.3063H50.6285ZM69.2886 46.5972L85.7788 87.6302H52.7501L69.2886 46.5972Z"
      fill="#016FD0"
    />
    <path
      d="M142.723 136.551V19.2867L189.384 19.4601L216.524 95.0646L243.015 19.2867H289.303V136.551H259.987V50.1458L228.911 136.551H203.201L172.039 50.1458V136.551H142.723Z"
      fill="#016FD0"
    />
    <path
      d="M44 273.723V155.723H142V182.118H74.3484V202.302H140.419V227.144H74.3484V248.104H142V273.723H44Z"
      fill="#016FD0"
    />
    <path
      d="M146.235 274.206L198.101 215.934L145 156.206H186.128L217.752 193.129L249.483 156.206H289L236.597 215.206L288.559 274.206H247.438L216.732 237.864L186.772 274.206H146.235Z"
      fill="#016FD0"
    />
  </svg>
);

const MastercardIcon = (props) => (
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="25.6359" height="17.5789" rx="1.46491" fill="black" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 12.5667C12.1283 13.3198 10.9962 13.7745 9.75906 13.7745C6.99868 13.7745 4.76096 11.5108 4.76096 8.71839C4.76096 5.92597 6.99868 3.66226 9.75906 3.66226C10.9962 3.66226 12.1283 4.11693 13.0011 4.8701C13.8738 4.11693 15.006 3.66226 16.2431 3.66226C19.0035 3.66226 21.2412 5.92597 21.2412 8.71839C21.2412 11.5108 19.0035 13.7745 16.2431 13.7745C15.006 13.7745 13.8738 13.3198 13.0011 12.5667Z"
      fill="#ED0006"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 12.5667C14.0757 11.6393 14.7572 10.2593 14.7572 8.71839C14.7572 7.17744 14.0757 5.79749 13.0011 4.8701C13.8738 4.11693 15.006 3.66226 16.2431 3.66226C19.0035 3.66226 21.2412 5.92597 21.2412 8.71839C21.2412 11.5108 19.0035 13.7745 16.2431 13.7745C15.006 13.7745 13.8738 13.3198 13.0011 12.5667Z"
      fill="#F9A000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.0011 4.87012C14.0757 5.7975 14.7572 7.17744 14.7572 8.71839C14.7572 10.2593 14.0757 11.6393 13.0011 12.5667C11.9265 11.6393 11.245 10.2593 11.245 8.71838C11.245 7.17744 11.9265 5.7975 13.0011 4.87012Z"
      fill="#FF5E00"
    />
  </svg>
);

const VisaIcon = (props) => (
  <svg
    width="27"
    height="19"
    viewBox="0 0 27 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.25"
      y="0.25"
      width="26.1359"
      height="18.0789"
      rx="1.71491"
      fill="white"
      stroke="#E5E5E5"
      strokeWidth="0.5"
    />
    <path
      d="M11.4679 12.2799H10.0183L10.925 6.67401H12.3744L11.4679 12.2799Z"
      fill="#142EBD"
    />
    <path
      d="M16.7219 6.81111C16.436 6.69769 15.9826 6.57245 15.4218 6.57245C13.9904 6.57245 12.9824 7.33577 12.9762 8.42708C12.9643 9.23226 13.6979 9.67947 14.2466 9.94794C14.8074 10.2223 14.998 10.4013 14.998 10.6459C14.9923 11.0214 14.5448 11.1945 14.1275 11.1945C13.5488 11.1945 13.2387 11.1053 12.7675 10.8963L12.5766 10.8068L12.3738 12.0652C12.7138 12.2201 13.3401 12.3575 13.9904 12.3635C15.5113 12.3635 16.5015 11.612 16.5132 10.449C16.519 9.81089 16.1316 9.3219 15.2965 8.92233C14.7895 8.66583 14.4791 8.49287 14.4791 8.23043C14.485 7.99184 14.7417 7.74747 15.314 7.74747C15.7852 7.7355 16.1314 7.84877 16.3937 7.96212L16.5248 8.02165L16.7219 6.81111Z"
      fill="#142EBD"
    />
    <path
      d="M18.6492 10.294C18.7686 9.9719 19.2279 8.72546 19.2279 8.72546C19.2219 8.73743 19.3471 8.39746 19.4186 8.18876L19.5199 8.6718C19.5199 8.6718 19.7944 10.0137 19.854 10.294C19.6275 10.294 18.9355 10.294 18.6492 10.294ZM20.4385 6.67401H19.3173C18.9715 6.67401 18.7088 6.77531 18.5596 7.13914L16.4066 12.2799H17.9275C17.9275 12.2799 18.1779 11.5879 18.2317 11.4389C18.3986 11.4389 19.8781 11.4389 20.0928 11.4389C20.1344 11.6357 20.2657 12.2799 20.2657 12.2799H21.6078L20.4385 6.67401Z"
      fill="#142EBD"
    />
    <path
      d="M8.80749 6.67401L7.38794 10.4967L7.23282 9.72142C6.97037 8.82684 6.14729 7.8549 5.22877 7.37162L6.52903 12.274H8.06185L10.3402 6.67401H8.80749Z"
      fill="#142EBD"
    />
    <path
      d="M6.06978 6.67401H3.73765L3.71379 6.78728C5.533 7.25249 6.73782 8.37384 7.23283 9.72166L6.72585 7.14524C6.64238 6.7872 6.38588 6.68582 6.06978 6.67401Z"
      fill="#142EBD"
    />
  </svg>
);

export const KlarnaIcon = (props) => (
  <svg
    width="26"
    height="18"
    viewBox="0 0 26 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="25.6359" height="17.5789" rx="1.46491" fill="#FEB4C7" />
    <path
      d="M3.97282 11.2648H2.92969V6.59204H3.97282V11.2648Z"
      fill="#181818"
    />
    <path
      d="M6.57711 6.59204H5.55659C5.55659 7.45195 5.17203 8.24122 4.50154 8.75758L4.09723 9.06886L5.6638 11.265H6.95182L5.51037 9.24422C6.19364 8.54473 6.57711 7.60366 6.57711 6.59204Z"
      fill="#181818"
    />
    <path d="M8.24092 11.2636H7.2558V6.59294H8.24092V11.2636Z" fill="#181818" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2173 8.0327V8.23937C10.9515 8.05295 10.6306 7.94339 10.2846 7.94339C9.36878 7.94339 8.62636 8.70666 8.62636 9.64819C8.62636 10.5897 9.36878 11.353 10.2846 11.353C10.6306 11.353 10.9515 11.2434 11.2173 11.0571V11.2635H12.1582V8.0327H11.2173ZM11.2144 9.64821C11.2144 10.1073 10.8327 10.4795 10.3618 10.4795C9.891 10.4795 9.50927 10.1073 9.50927 9.64821C9.50927 9.18912 9.891 8.81703 10.3618 8.81703C10.8327 8.81703 11.2144 9.18912 11.2144 9.64821Z"
      fill="#181818"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1437 8.23937V8.0327H22.0846V11.2635H21.1437V11.0571C20.8779 11.2434 20.5571 11.353 20.211 11.353C19.2952 11.353 18.5527 10.5897 18.5527 9.64819C18.5527 8.70666 19.2952 7.94339 20.211 7.94339C20.5571 7.94339 20.8779 8.05295 21.1437 8.23937ZM20.2882 10.4795C20.7591 10.4795 21.1408 10.1073 21.1408 9.64821C21.1408 9.18912 20.7591 8.81703 20.2882 8.81703C19.8174 8.81703 19.4357 9.18912 19.4357 9.64821C19.4357 10.1073 19.8174 10.4795 20.2882 10.4795Z"
      fill="#181818"
    />
    <path
      d="M16.8808 7.9458C16.5049 7.9458 16.1492 8.06576 15.9114 8.39674V8.03289H14.9745V11.2636H15.9229V9.56572C15.9229 9.07442 16.2433 8.83383 16.6292 8.83383C17.0427 8.83383 17.2804 9.0878 17.2804 9.55904V11.2636H18.2202V9.20899C18.2202 8.45712 17.6388 7.9458 16.8808 7.9458Z"
      fill="#181818"
    />
    <path
      d="M13.6137 8.03275V8.45355C13.8024 8.20114 14.1538 8.03294 14.5359 8.03294V8.97307L14.5329 8.97297L14.5286 8.97275L14.5247 8.97264C14.1524 8.97264 13.6159 9.2462 13.6159 9.75512V11.2636H12.6504V8.03275H13.6137Z"
      fill="#181818"
    />
    <path
      d="M22.493 10.7247C22.493 10.3894 22.7573 10.1176 23.0834 10.1176C23.4095 10.1176 23.6739 10.3894 23.6739 10.7247C23.6739 11.0599 23.4095 11.3317 23.0834 11.3317C22.7573 11.3317 22.493 11.0599 22.493 10.7247Z"
      fill="#181818"
    />
  </svg>
);

export const CardGeneralIcon = (props) => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.55 4.75313V10.2984C17.55 10.9287 17.2726 11.5332 16.779 11.9789C16.2853 12.4246 15.6157 12.675 14.9175 12.675H2.6325C1.93432 12.675 1.26473 12.4246 0.771041 11.9789C0.277352 11.5332 0 10.9287 0 10.2984V4.75313H17.55ZM14.04 7.92188H11.4075C11.1748 7.92188 10.9516 8.00534 10.787 8.1539C10.6224 8.30247 10.53 8.50396 10.53 8.71406C10.53 8.92416 10.6224 9.12566 10.787 9.27422C10.9516 9.42279 11.1748 9.50625 11.4075 9.50625H14.04C14.2727 9.50625 14.4959 9.42279 14.6605 9.27422C14.825 9.12566 14.9175 8.92416 14.9175 8.71406C14.9175 8.50396 14.825 8.30247 14.6605 8.1539C14.4959 8.00534 14.2727 7.92188 14.04 7.92188ZM14.9175 0C15.6157 0 16.2853 0.250387 16.779 0.696079C17.2726 1.14177 17.55 1.74626 17.55 2.37656V3.16875H0V2.37656C0 1.74626 0.277352 1.14177 0.771041 0.696079C1.26473 0.250387 1.93432 0 2.6325 0H14.9175Z"
      fill="white"
    />
  </svg>
);

export const BankIcon = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0L0 3.33333V4.66667H14V3.33333M10.3158 6V10.6667H12.5263V6M0 14H14V12H0M5.89474 6V10.6667H8.10526V6M1.47368 6V10.6667H3.68421V6H1.47368Z"
      fill="white"
    />
  </svg>
);

const cardNetworkIcons = {
  Visa: VisaIcon,
  MasterCard: MastercardIcon,
  AmericanExpress: AmexIcon,
  Klarna: KlarnaIcon,
  CardGeneral: CardGeneralIcon,
  Bank: BankIcon,
};

const CardNetworkIcon = ({ network }) => {
  const Icon = cardNetworkIcons[network];
  if (!Icon) {
    return (
      <span className="inline-flex items-center justify-center w-10 h-7 rounded bg-zinc-200 text-[9px] font-semibold text-zinc-600">
        {network || "Card"}
      </span>
    );
  }
  return <Icon />;
};

export default CardNetworkIcon;
